module.exports = __webpack_public_path__ + "static/media/about.9e9528e3.jpg";